import { useCallback } from "react";
import { FormFieldType } from './types';
import { InputField } from "./components/InputField";
import { DropdownField } from "./components/DropdownField";

export const FormField = ({type, ...rest}: FormFieldType) => {
    const field = useCallback(() => {
            switch(type) {
            case "select":
                return DropdownField;
            default:
                return InputField;
        }
    },[type])

    return field()({type, ...rest})
};